import { selectComponentState } from 'projectRedux/store';
import { eppDamperAdapter } from '../adapters/eppDamperAdapter';

export const {
  selectAll: selectAllEppDampers,
  selectById: selectEppDamperById,
  selectEntities: selectEppDamperEntities,
} = eppDamperAdapter.getSelectors((state) => selectComponentState(state).eppDampers);
